import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseFormService } from '../BaseFormService';
import { UtilityService } from '../utility.service';

@Injectable({
	providedIn: 'root',
})
export class ItemService extends BaseFormService {
	constructor(httpClient: HttpClient, utilityService: UtilityService) {
		super(`${environment.apiUrl}inventory/clients/$$clientId$$/item`, httpClient, utilityService);
	}
	getAll(clientId: string): Observable<any[]> {
		return super.getAll(clientId).pipe(map((items: any[]) => ItemService.sortByName(items)));
	}
	getAllForManagement(clientId: string): Observable<any[]> {
		return this.httpClient
			.get<any[]>(`${this.getUrl(clientId)}/management`)
			.pipe(map((items: any[]) => ItemService.sortByName(items)));
	}
	setActiveState(clientId: string, itemIds: string[], isActive: boolean): Observable<void> {
		return this.httpClient.put<void>(`${this.getUrl(clientId)}/active-state`, { itemIds, isActive });
	}
	private static sortByName(items: any[]): any[] {
		return (items ?? [])
			.slice()
			.sort((a, b) => (a?.itemName ?? '').localeCompare(b?.itemName ?? '', undefined, { sensitivity: 'base' }));
	}
	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.getUrl(clientId)}/${id}/approval`, {
				userId,
			})
			.pipe();
	}
	GetItemDetail(clientId: string, id: any): Observable<any> {
		return this.httpClient.get<any>(`${this.getUrl(clientId)}/${id}/item-detail`).pipe();
	}
	importItems(clientId: string, request: any): Observable<any[]> {
		return this.httpClient.post<any[]>(`${this.getUrl(clientId)}/import`, request).pipe();
	}
	getPriceHistory(clientId: string, id: any): Observable<any[]> {
		return this.httpClient.get<any[]>(`${this.getUrl(clientId)}/${id}/price-history`).pipe();
	}
}
